import ActionTypes from '../../constants/ActionTypes';

const initialState = {
  data: {
    name: 'dashboard',
    type: '1',
    description: '',
    empty: false,
    title: '',
    dataType: '',
    interval: 900,
    itemName: '',
    itemNames: '',
    position: 0,
    unitName: '',
    deviceIds: '',
    factoryIds: '',
    decimalPoint: '',
    min: '',
    max: '',
  },
  isSubmitting: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.COMPONENT_CREATE:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload.data,
        },
      };
    case ActionTypes.COMPONENT_CREATE_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
      };
    case ActionTypes.COMPONENT_CREATE_SUCCESSDED:
      return initialState;
    case ActionTypes.COMPONENT_CREATE_FAILED:
      return {
        ...state,
        isSubmitting: false,
      };
    default:
      return state;
  }
};
